import BreakpointsHelper from '../../../helpers/BreakpointsHelper/BreakpointsHelper'

export const DisplayTitle = ({ title }: { title?: string }) => {
  return (
    <h2 style={{ fontSize: BreakpointsHelper.isMobile() ? '2.5rem' : '2.875rem', lineHeight: '3.5rem', color: 'inherit', marginBottom: '10px', maxWidth: '750px' }}>
      {title}
    </h2>
  )
}
